export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8325.6ba5b11a.jpg";